import axios from "axios";
import { http_post } from "./helpers";
import { version } from "./config";
import { TasksItem, taskFilesItem, TaskNoticesItem, TaskUserCommitsItem, taskFile, upLoadFile } from "./types";

export const getMyParentProductTypes = http_post<void, any>(
    `/api/v${version}/m/Product/QueryMyParentProductTypes`
);
// 获取作业列表
export const tasks_pageList = http_post<
    {
        typeId?: number | null;
        name?: string;
        sorting?: string;
        skipCount: number;
        maxResultCount: number;
    },
    {
        totalCount: number;
        items: TasksItem[] | [];
    }
>(`/api/v${version}/m/MyStuding/QueryMyTasks`);

// 作业资料-分页
export const myTasks_files = http_post<
    {
        taskId: string | number;
        isTaskRule?: boolean;
        isLocked: boolean;
        skipCount: number;
        maxResultCount: number;
    },
    {
        totalCount: number;
        items: taskFilesItem[] | [];
    }
>(`/api/v${version}/m/MyStuding/{taskId}/QueryMyTaskFiles`);

// 某个学生  我的提交情况查询
export const MyTaskUserCommits_Page = http_post<
    {
        taskId: string | number;
        isCommit?: boolean;
        sorting?: string;
        skipCount: number;
        maxResultCount: number;
    },
    {
        totalCount: number;
        items: TaskUserCommitsItem[] | [];
    }
>(`/api/v${version}/m/MyStuding/{taskId}/MyTaskUserCommits_Page`);

// 作业通知
export const MyTaskNotices = http_post<
    {
        taskId: number | string;
        sorting?: string;
        skipCount: number;
        maxResultCount: number;
    },
    {
        totalCount: number;
        items: TaskNoticesItem[];
    }
>(`/api/v${version}/m/MyStuding/{taskId}/MyTaskNotices_Page`);

export const MyTaskCommitSubmit = http_post<
    {
        taskId: string | number;
        uploadFileId: number;
        attachFileIdList: number[] | undefined;
    },
    {
        success: boolean;
        code: number;
        data: string | number;
    }
>(`/api/v${version}/m/MyStuding/{taskId}/MyTaskCommitSubmit`);

export const submitDataFile = http_post<
    {
        taskId: string | number;
        taskFile: taskFile;
        uploadFile: upLoadFile;
    },
    {
        success: boolean;
        code: number;
        data: string | number;
    }
>(`/api/v${version}/m/MyStuding/{taskId}/TaskFilesSave`);

export const getDataFile = http_post<{
    type?: number | string;
    taskCommitId?: number | string;
    taskId?: number | string;
    ids?: string[];
    filter?: string;
    sorting?: string;
    skipCount?: number;
    maxResultCount?: number;
},
{
    totalCount: number;
    items: any[] ;
}>(`/api/v${version}/m/UploadFiles/UploadFiles_PageList`);

export const DeleteCommit = http_post<
    {
        taskId: string | number;
        commitId: string | number;
    },
    {
        success: boolean;
        code: number;
        data: string | number;
    }
>(`/api/v${version}/m/MyStuding/{taskId}/{commitId}/MyTaskCommitRemove`);

// 保存文件
export const uploadFiles_Save = http_post<
    {
        fileId: string;
        fileName: string;
        fileExtention: string;
        fileTaskId?: string;
        fileConvertState?: number;
        fileHash?: string;
        fileSize: number;
        fileUrl: string;
        modelGroupId: string;
        type: number;
        isLocked?: boolean;
        creationTime?: string;
        createUserId?: string | number;
        id?: string | number;
    },
    {
        success: boolean;
        code: number;
        data: string | number;
    }
>(`/api/v${version}/m/UploadFiles/UploadFiles_Save`);

// 获取报告
export const checkReport = http_post<
    {
        taskCommitId: any;
        userId: any;
    },
    void
>(`/api/v${version}/m/MyStuding/UserCheckReport`);

// 批注列表
export const TaskOpinions_GetList = http_post<
    {
        taskId: string;
        commitId: string;
    },
    void
>(`/api/v${version}/m/MyStuding/{taskId}/{commitId}/MyTaskOpinions_GetList`);
export const QueryMyUploadFiles = http_post<
{
    type: number;
    taskCommitId?: number;
    taskId: number;
    ids?: number[]|string[];
    filter?: string;
    sorting?: string;
    skipCount: number;
    maxResultCount: number;
  },
    void
>(`/api/v${version}/m/MyStuding/QueryMyUploadFiles`);
export const TaskFilesRemove = http_post<
{
   id: string;
  },
    void
>(`/api/v${version}/m/MyStuding/TaskFilesRemove`);

export const uploadFileToTask = http_post<
    { taskId: number | string; taskFile: any; uploadFile: any },
    void
>(`/api/v${version}/m/MyStuding/{taskId}/TaskFilesSave`);
// 模型转换
export const convertModel = (data: { fileId: string; tessLevel: number }, sessionId) =>
    axios.post(`${process.env.VUE_APP_ENGINEURL}/Boron/ConvertFile`, data, {
        headers: {
            // eslint-disable-next-line prefer-template
            Authorization: "Bearer " + sessionId
        }
    });
// 模型转换进度
export const getConvertProgress = (data: { fileId: string }, sessionId) =>
    axios.get(`${process.env.VUE_APP_ENGINEURL}/Boron/GetConvertProgress?fileId=${data.fileId}`, {
        headers: {
            // eslint-disable-next-line prefer-template
            Authorization: "Bearer " + sessionId
        }
    });
// 下载文件
export const downloadFile = (data: { fileId: string }, sessionId) =>
    axios.post(
        `${process.env.VUE_APP_ENGINEURL}/Boron/DownloadFile/Original/${data.fileId}`,
        {},
        {
            headers: {
                // eslint-disable-next-line prefer-template
                Authorization: "Bearer " + sessionId
            },
            responseType: "arraybuffer"
        }
    );

export const getById = (data: { fileId: string; instanceId: number }, sessionId) =>
    axios.get(
        `${process.env.VUE_APP_ENGINEURL}/Boron/GetInstanceProperty?fileId=${data.fileId}&instanceId=${data.instanceId}`,
        {
            headers: {
                Authorization: `${"Bearer "}${sessionId}`
            }
        }
    );
export const getModelTree = (data: { fileId: string }, sessionId) =>
    axios.get(`${process.env.VUE_APP_ENGINEURL}/Boron/GetModelLevelTree?fileId=${data.fileId}`, {
        headers: {
            Authorization: `${"Bearer "}${sessionId}`
        }
    });

// 获取sessionId
export const getSessionId = http_post<void, any>(
    `/api/v${version}/m/UploadFiles/FileServer_GetSessionId`
);

function convert_uuid_can_read(str) {
    // const string__ = '0123456789abcdef';
    // eslint-disable-next-line no-underscore-dangle
    const __id = str;
    let newid = "";
    for (let i = 0; i < __id.length; i++) {
        const numchar = __id.charCodeAt(i).toString(16);
        const s = 4 - numchar.length;
        let ch = "";
        for (let n = 0; n < s; n++) {
            ch += "0";
        }
        newid += ch + numchar;
    }
    return newid;
}

export function strToInt32(byteGuid) {
    const newId = convert_uuid_can_read(byteGuid);
    const strnum = newId.substr(0, 4);
    const strnumnew = strnum[2] + strnum[3] + strnum[0] + strnum[1];
    const numchar1 = parseInt(strnumnew, 0x10);
    return numchar1;
}
export function convert_uuid_byte(newid) {
    // eslint-disable-next-line no-underscore-dangle
    let string__ = "";
    // eslint-disable-next-line radix
    const alllength = parseInt(`${newid.length / 4}`);
    for (let i = 0; i < alllength; i++) {
        let strnum = "";
        for (let n = 0; n < 4; n++) {
            strnum += newid[i * 4 + n];
        }
        const xxxx_str = String.fromCharCode(parseInt(strnum, 16));
        string__ += xxxx_str;
    }
    return string__;
}

export function convert_instanceid_to_uuid(intanceid, newModelId) {
    function add_zero(str, size) {
        if (str.length < size) {
            for (let i = 0; i < size - str.length; i++) {
                str = `0${str}`;
            }
        }
        return str;
    }
    let high = (intanceid % 0x100).toString(16);
    // eslint-disable-next-line radix
    let low = parseInt(`${intanceid / 0x100}`).toString(16);
    let tail_newId = newModelId.toString(16);
    let tail_originId = "00"; // newModelId.toString(16);
    high = add_zero(high, 2);
    low = add_zero(low, 2);
    tail_newId = add_zero(tail_newId, 2);
    tail_originId = add_zero(tail_originId, 2);
    const string = `${high + low}0000000000000000000000000000${tail_newId}${tail_originId}`;
    return string;
}

export const generateComponentDetail: (
    params: { properties: { innerName: string; displayValue: string } }[]
) => { key: string; value: string }[] = components => {
    const allProperties = components.map(v => v.properties).flat();
    const details = allProperties
        .map(v => ({
            key: v.innerName,
            value: v.displayValue
        }))
        .filter(v => v.value);
    return details;
};
